import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import LocationCircleSvg from "src/components/svg/LocationCircleSvg";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import styles from "./LocationSelectorButton.module.css";
import { locale } from "@locale";

//#region [Props]
type LocationSelectorButtonProps = {
  className?: string;
  iconButtonClassName?: string;
  showTextLabel?: boolean;
};
//#endregion

//#region [Component]
export default function LocationSelectorButton(t0) {
  const $ = _c(17);
  const {
    className,
    iconButtonClassName,
    showTextLabel: t1
  } = t0;
  const showTextLabel = t1 === undefined ? false : t1;
  const locationContext = useLocationContext();
  let t2;
  if ($[0] !== className) {
    t2 = classNames(styles.LocationSelectorButtonContainer, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== locationContext) {
    t3 = () => locationContext.setShowLocationDialog(true);
    $[2] = locationContext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== locationContext.location?.length || $[5] !== showTextLabel) {
    t4 = showTextLabel && <span className={styles.LocationSelectorButtonLabel}>{(locationContext.location?.length ?? 0) === 0 ? locale.program.selectLocation : locale.program.changeLocation}</span>;
    $[4] = locationContext.location?.length;
    $[5] = showTextLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== iconButtonClassName) {
    t5 = classNames(styles.LocationSelectorIcon, iconButtonClassName);
    $[7] = iconButtonClassName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LocationCircleSvg />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <span className={t5}>{t6}</span>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <button className={t2} onClick={t3}>{t4}{t7}</button>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
//#endregion